export const getBlewittSpringsData = () => ({
  name: "Blewitt Springs",
  country: "Australie",
  region: "McLaren Vale",
  description: "Blewitt Springs est une sous-région de McLaren Vale, réputée pour ses vins rouges élégants et ses blancs frais. Ses sols sableux et son climat méditerranéen créent des conditions idéales pour des vins de grande finesse.",
  type: "subregion",
  mapAreas: [
    { region: "Blewitt Springs", x: 40, y: 80, color: "#a768a6", size: 3 }
  ],
  statistics: {
    totalArea: "1,500 ha",
    production: "0.1 million hectolitres",
    altitude: "100-200m",
    appellations: "Blewitt Springs GI",
    exportPercentage: "35%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influence océanique, étés chauds et secs, hivers doux",
    soil: "Sols sableux, excellente drainage, faible rétention d'eau",
    viticulture: "Viticulture moderne, sols sableux, rendements limités"
  },
  wineStyles: {
    red: "Shiraz élégants et fruités, Grenache délicats, assemblages complexes",
    white: "Chardonnay aromatiques, Sauvignon Blanc frais, Sémillon complexes",
    rose: "Rosés fruités et vifs, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "Blewitt Springs s'est développée comme sous-région distincte dans les années 1990. La sous-région s'est rapidement imposée pour ses vins élégants et ses sols sableux uniques.",
  foodPairing: "Cuisine australienne : barbecue, viandes rouges, fruits de mer, fromages affinés, cuisine fusion.",
  grapeVarieties: {
    white: ["Chardonnay", "Sauvignon Blanc"],
    red: ["Shiraz", "Grenache", "Cabernet Sauvignon"]
  },
  keyProducers: ["Wirra Wirra", "d'Arenberg", "Chapel Hill"],
  notableWines: {
    "shiraz": "Shiraz élégants et fruités",
    "grenache": "Grenache délicats et épicés",
    "chardonnay": "Chardonnay aromatiques et frais"
  }
}); 